import { SkladNovychVozu } from './skladNovychVozu';
import { ProdejNovychVozu } from './prodejNovychVozu';

export const menu = {
	name: 'NV_NoveVozy',
	list: [
		SkladNovychVozu.menu,
		{ name: 'NV_Prodeje', route: ProdejNovychVozu.name },
		{ name: 'NV_ArchivDokl', route: 'ArchyvDokladu' },
		{
			name: 'NV_Nabidky',
			list: [
				{ name: 'NV_Nabidky', route: 'Nabidky' },
			],
		},
	],
};
